import { render } from "./StoresRevenue.vue?vue&type=template&id=3882a4af"
import script from "./StoresRevenue.vue?vue&type=script&lang=js"
export * from "./StoresRevenue.vue?vue&type=script&lang=js"

import "./StoresRevenue.vue?vue&type=style&index=0&id=3882a4af&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__